<template>
    <b-modal
        id="class-link-modal"
        v-model="showModal"
        ref="class-link-modal"
        size="lg"
        :title="$t('group.internship.select_groups')"
        modal-class="apprentice-default-modal"
        header-class="header"
        ok-only
        :ok-title="$t('common.close')">
        <b-tabs
            class="apprentice-tab link-modal-tabs"
            content-class="group-settings-las-link-content">
            <b-tab
                :title="$t('group.internship.classes')"
                active>
                <design-2021-group-show-las-group-component
                    :las-groups-in="lasGroups"
                    @remove-las-group="removeLasGroup"
                    @add-las-group="addLasGroup">
                </design-2021-group-show-las-group-component>
            </b-tab>
            <b-tab :title="$t('group.internship.main_groups')">
                <design-2021-group-show-las-main-group-component
                    :las-main-groups-in="lasMainGroups"
                    @add-las-main-group="addLasMainGroup"
                    @remove-las-main-group="removeLasMainGroup">
                </design-2021-group-show-las-main-group-component>
            </b-tab>
        </b-tabs>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-show-link-class-modal-component',
    props: ['groupIn', 'resetSelectForm'],
    data() {
        return {
            group: this.groupIn,
            lasGroups: [],
            lasMainGroups: [],
            showModal: false,
            dataLoaded: false,
        };
    },
    methods: {
        show() {
            if (this.dataLoaded) {
                this.showModal = true;
                return;
            }

            this.alert.loading();

            const promises = [this.getLasGroups(), this.getLasMainGroups()];

            Promise.all(promises).then(
                (response) => {
                    this.dataLoaded = true;
                    this.showModal = true;
                    this.alert.loaded();
                },
                (error) => {},
            );
        },
        getLasGroups() {
            return this.axios.get(this.routes.getLasGroups()).then(
                (response) => {
                    this.lasGroups = response.data.map((group) => {
                        group.checked = false;
                        for (const g of this.group.las_groups) {
                            if (g.id === group.id) {
                                group.checked = true;
                                break;
                            }
                        }
                        return group;
                    });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        getLasMainGroups() {
            return this.axios.get(this.routes.getLasMainGroups()).then(
                (response) => {
                    this.lasMainGroups = response.data.map((group) => {
                        group.checked = false;
                        for (const g of this.group.las_main_groups) {
                            if (g.id === group.id) {
                                group.checked = true;
                                break;
                            }
                        }
                        return group;
                    });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        addLasGroup(data) {
            this.$emit('linkGroup', data.id, 1);
            this.lasGroups.map((group) => {
                if (group.id === data.id) {
                    data.checked = true;

                    return data;
                }
            });
        },
        removeLasGroup(data) {
            this.$emit('unLinkGroup', data.id, 1);
            this.lasGroups.map((group) => {
                if (group.id === data.id) {
                    data.checked = false;

                    return data;
                }
            });
        },
        addLasMainGroup(data) {
            this.$emit('linkGroup', data.id, 2);
            this.lasMainGroups.map((group) => {
                if (group.id === data.id) {
                    data.checked = true;

                    return data;
                }
            });
        },
        removeLasMainGroup(data) {
            this.$emit('unLinkGroup', data.id, 2);
            this.lasMainGroups.map((group) => {
                if (group.id === data.id) {
                    data.checked = false;

                    return data;
                }
            });
        },
    },
    watch: {
        resetSelectForm: function (value) {
            if (value === true) {
                this.$emit('formHasBeenReset', true);
            }
        },
    },
};
</script>

<style scoped lang="scss"></style>
